import React, { useState, useEffect, useRef } from "react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import {
  Filter,
  PlusCircle,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Table from "../../core/pagination/datatable";
import Axios from "axios";
import { setlocalindentlist_data } from "../../core/redux/action";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  API_BASE_URL,
  DOWNLD_EXCEL,
  GET_VSTORE_PROD,
  UPDATES_INDENT_STATUS,
  GET_STOCK_INDENT,
  GET_STOCK_INDENT_LIST,
  INSERT_STOCK_INDENT,
  UPLOAD_EXCEL,
  GET_USER_STORES,
  RECEIVE_LOCAL_INDENT_STOCK,
  DELETE_INDENT,
} from "../../Config";
import "../../style/css/loader.css";
import Swal from "sweetalert2";
import withReactContent from 'sweetalert2-react-content';
import { getUserPermissions } from "../../UserPermissions";
import UploadFiles from "../UploadFiles";
import SpinLoader from "../loader/SpinLoader";


const LocalIndent = () => {
  const [userDataSession, setUserDataSession] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [rejectloading, setRejectLoading] = useState(false);
  const [excelErrorMess, setExcelErrorMess] = useState("");
  const [editSubmitLoading, setEditSubmitLoading] = useState(false);
  const [offcanvasWidth, setOffcanvasWidth] = useState("50%");
  const [selectedProduct, setSelectedProduct] = useState(null);
  

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setOffcanvasWidth("85%");
      } else {
        setOffcanvasWidth("50%");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  // #region Session userdetails
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
      // console.log(userData);
    } else {
      console.log("User data not found in sessionStorage");
      navigate("/");
    }
  }, [navigate]);

  const [permissions, setPermissions] = useState({
    isRead: "d-none",
    isWrite: "d-none",
    isDelete: "d-none",
    isExport: "d-none",
  });

  useEffect(() => {
    const perms = getUserPermissions("Indent");
    setPermissions(perms);
  }, []);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      Axios.get(
        `${API_BASE_URL}${GET_USER_STORES}?OrgId=${userDataSession.OrgId}&UserId=${userDataSession.UserId}`
      )
        .then((response) => {
          if (response.data) {
            setStoreData(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }
  }, [userDataSession]);

  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const dataSource = useSelector((state) => state.localindentlist_data) || [];

  // const [searchQuery, setSearchQuery] = useState('');
  const [storeData, setStoreData] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const [rejectedReason, setRejectedReason] = useState("");

  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedFilterStore, setSelctedFilterStore] = useState(null);
  const [indentProducts, setIndentProducts] = useState([]);
  const [selectedFilterDate, setSelectedFilterDate] = useState(null);

  const today = new Date().toISOString().split("T")[0];
  const [selectedDate, setSelectedDate] = useState(today);

  const [selectedProducts, setSelectedProducts] = useState([]);

  const [editObj, setEditObj] = useState([]);
  const [viewObj, setViewObj] = useState([]);
  const [receiveObj, setReceiveObj] = useState([]);

  const [selectedFile, setSelectedFile] = useState(null);
  // const [selctedOperation, setSelctedOperation] = useState(null);
  // const [selctedOperationEdit, setSelctedOperationEdit] = useState(null);
  const [submitBtnLoading, setSubmitBtnLoading] = useState(false);
  const [draftEditBtnLoading, setDraftEditBtnLoading] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [viewLoading, setViewLoading] = useState(false);
  const [receiveLoading, setReceiveLoading] = useState(false);
  const [isDisplayProduct, setIsDisplayProduct] = useState(true);
  const [isDisplayExcel, setIsDisplayExcel] = useState(false);
  const [isDisplayProductBtn, setIsDisplayProductBtn] = useState(true);
  const [isDisplayExcelBtn, setIsDisplayExcelBtn] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [uploadInvoiceObj, setUploadInvoiceObj] = useState([]); 

  // const [filteredData, setFilteredData] = useState(dataSource);

  const fetchStockIndentList = () => {
    if (userDataSession && userDataSession.OrgId) {
      setLoading(true);
      Axios.get(
        `${API_BASE_URL}${GET_STOCK_INDENT}?OrgId=${
          userDataSession.OrgId}&StoreId=0&IndentDt=0&UserId=${userDataSession.UserId}&Status=0&Type=1`)
        .then((response) => {
          // console.log(response.data, 'GET_STOCK_INDENT')
          if (response.data.Status) {
            dispatch(setlocalindentlist_data(response.data.ResultData));
            // console.log(response.data.ResultData);
            setLoading(false);
          } else {
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId) {
      fetchStockIndentList();
    }
  }, [userDataSession]);

  // #region Getting Indents
  const fetchFilterData = () => {
    if (
      userDataSession &&
      userDataSession.OrgId &&
      (selectedFilterStore || selectedFilterDate)
    ) {
      setLoading(true);
      let indentdate = 0;
      let storeid = 0;

      if (selectedFilterStore) {
        storeid = selectedFilterStore.value;
      }
      if (selectedFilterDate) {
        indentdate = selectedFilterDate;
      }

      Axios.get(
        `${API_BASE_URL}${GET_STOCK_INDENT}?OrgId=${userDataSession.OrgId}&StoreId=${storeid}&IndentDt=${indentdate}&UserId=${userDataSession.UserId}&Type=1`
      )
        .then((response) => {
          if (response.data.Status) {
            dispatch(setlocalindentlist_data(response.data.ResultData));
            setLoading(false);
          } else {
            dispatch(setlocalindentlist_data(response.data.ResultData));
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          dispatch(setlocalindentlist_data([]));
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  };

  const handleFilterDateChange = (event) => {
    setSelectedFilterDate(event.target.value);
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleStoreFilterChange = (selectedOption) => {
    setSelctedFilterStore(selectedOption);
  };

  useEffect(() => {
    if (storeData.length === 1) {
      const selectedStoreObj = {
        value: storeData[0].StoreId,
        label: storeData[0].Name,
      };
      setSelectedStore(selectedStoreObj);
      setSelctedFilterStore(selectedStoreObj);
    }
  }, [storeData]);

  // #region Getting Store Products
  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && selectedStore) {
      const requestData = {
        OrgId: userDataSession.OrgId,
        CategoryId: 0,
        BarCode: "0",
        IsActive: 1,
        ProductId: 0,
        StoreId: selectedStore ? selectedStore.value : 0,
        IsForSale: 1,
        UserId: userDataSession.UserId,
        Type: 1,
      };
      Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
        .then((response) => {
          if (response.data) {
            setProductsData(response.data.ResultData);
          } else {
            setProductsData([]);
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          setProductsData([]);
          console.error("Error fetching data:", error);
        });
    }
  }, [selectedStore]);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );

  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const statusOrder = {
    11: "Draft",
    12: "Sent",
    13: "Approved",
    14: "Reject",
    15: "Completed",
  };

  const statusClassNames = {
    11: "badge badge-warning",
    12: "badge badge-secondary",
    13: "badge badge-info",
    14: "badge badge-danger",
    15: "badge badge-success",
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const editFormatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredDataSource = dataSource?.filter((item) => {
    return (
      (item.IndentNo &&
        item.IndentNo.toLowerCase().includes(searchQuery.toLowerCase())) ||
      (item.StoreName &&
        item.StoreName.toLowerCase().includes(searchQuery.toLowerCase()))
    );
  });

  const showUploadFilesModal = (indentObj) => {
    setUploadInvoiceObj(indentObj);
  };

  // #region Assigning Data to Table
  const columns = [
    {
      title: "Number",
      dataIndex: "IndentNo",
      sorter: (a, b) => {
        const aValue = a.IndentNo || "";
        const bValue = b.IndentNo || "";
        return aValue.localeCompare(bValue);
      },
    },
    {
      title: "Date",
      dataIndex: "IndentDt",
      sorter: (a, b) => new Date(a.IndentDt) - new Date(b.IndentDt),
      render: (text) => formatDate(text),
    },
    {
      title: "Store",
      dataIndex: "StoreName",
      sorter: (a, b) => a.StoreName.localeCompare(b.StoreName),
    },
    {
      title: "Products",
      dataIndex: "ProductCount",
      render: (record) => (record ? record : "0"),
    },
    {
      title: "Status",
      dataIndex: "IndentStatus",
      sorter: (a, b) => a.IndentStatus - b.IndentStatus,
      render: (status) => (
        <span className={statusClassNames[status]}>{statusOrder[status]}</span>
      ),
    },

    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <td>
          <div className="edit-delete-action">
            <Link
              to="#"
              className="dropdown-oggle nav-lik selet-store"
              data-bs-toggle="dropdown"
            >
              <i className="fa-solid fa-ellipsis-vertical btn border"></i>
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              <Link
                to="#"
                className={`dropdown-item ms-3 mb-3 mt-2 ${permissions.isRead}`}
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightLocalIndView"
                aria-controls="offcanvasRightLocalIndView"
                onClick={() => showViewModal(record)}
              >
                <i className="fa-regular fa-eye me-2"></i>
                View
              </Link>
              <Link
                to="#"
                className={`dropdown-item ms-3 mb-3 mt-3  ${
                  record.IndentStatus == 11 ? "" : "disabled"
                }`}
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightIndEdit"
                aria-controls="offcanvasRightIndEdit"
                onClick={() => showEditModal(record)}
              >
                <i className="fa-regular fa-pen-to-square me-2"></i>
                Edit
              </Link>
              <Link
                to="#"
                className={`dropdown-item ms-3 mb-3 ${
                  userDataSession.RoleId === 1 ||
                  userDataSession.RoleId === 3 &&
                  record.IndentStatus === 13
                    ? ""
                    : "disabled"
                }`}
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightLocalIndReceive"
                aria-controls="offcanvasRightLocalIndReceive"
                onClick={() => showReceiveModal(record)}
              >
                <i className="fa-solid fa-download me-2"></i>
                Received
              </Link>
              <Link
                to="#" 
                className={`dropdown-item ms-3 mb-3 ${record.IndentStatus === 11 || record.IndentStatus === 14 ? 'disabled' : ''}`}
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightUploadFiles"
                aria-controls="offcanvasRightUploadFiles"
                onClick={() => showUploadFilesModal(record)}
              >
                  <i className="fa-solid fa-cloud-arrow-up me-2"></i>Upload Files
              </Link>
              <Link
                to="#"
                className={`dropdown-item ms-3 mb-3 mt-2 ${ userDataSession.RoleId === 3 && record.IndentStatus === 11 ? '' : 'disabled'}`}
                onClick={() => showConfirmationAlert(record)}
              >
                <i className="fa-regular fa-trash-can me-2"></i>
                Delete
              </Link>
            </div>
          </div>
        </td>
      ),
    },
  ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (record) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this indent?",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteIndent(record.IndentNo);
      } else {
        MySwal.close();
      }
    });
  };

  const deleteIndent = (recordId) => {
    const deleteData = {
      UserId: userDataSession.UserId,
      IndentNo: recordId,
    };
    console.log(deleteData, 'data sending to api fro del')
  
    // Make the DELETE request to the API
    Axios.post(`${API_BASE_URL}${DELETE_INDENT}`, deleteData)
      .then((response) => {
        console.log(response.data.ResultData[0].Status);
        if (response.data.ResultData[0].Status === 'Success') {
          MySwal.fire({
            title: "Deleted!",
            text: "The indent has been deleted.",
            icon: "success",
          }).then(() => {
            fetchStockIndentList();
          });
        } else {
          MySwal.fire({
            title: "Failed!",
            text: response.data.Message || "Failed to delete the indent.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        console.error("Error deleting indent:", error);
        MySwal.fire({
          title: "Error!",
          text: "An error occurred while deleting the indent.",
          icon: "error",
        });
      });
  };

  const handleStoreSelectChange = (selectedOption) => {
    setSelectedStore(selectedOption);
    setExcelErrorMess("");
  };

  const handleProductSelectChange = (value) => {
    setErrorMessage(`Excel upload is disabled because products have already been selected.<br/>
      Please clear the selected products to enable Excel upload.`);

   setSelectedProduct(value);
   setIsDisplayExcel(true);
   setIsDisplayExcelBtn(false);
   setIsDisplayProductBtn(true);
    // Check if product is already selected
    const isProductSelected = selectedProducts.some(
      (product) => product.id === value.value
    );
  
    if (isProductSelected) {
      alert("Product already selected!");
      return;
    }
  
    // If not selected, proceed to add the product
    const product = {
      id: value.value,
      name: value.label,
      quantity: "",
    };
    setSelectedProducts([...selectedProducts, product]);
  };
  
  const handleQuantityChange = (value, index) => {
    const updatedProducts = [...selectedProducts];
    updatedProducts[index].quantity = value;
    setSelectedProducts(updatedProducts);
  };

  const handleDelete = (index, event) => {
    event.preventDefault(); // Prevent the form from submitting
    setSelectedProducts((prevData) => prevData.filter((_, i) => i !== index));
  };

  // #region handlesubmit Add
  const handleSubmit = (operation) => async (e) => {
    e.preventDefault();
    // setSelctedOperation(operation);

    console.log(selectedProducts, "selected prods");

    const payload = {
      StoreName: `${selectedStore.label}`,
      StockIndent: [
        {
          OrgId: userDataSession.OrgId,
          StoreId: selectedStore?.value,
          IndentDt: selectedDate,
          Operation: operation,
          UserId: userDataSession.UserId,
          IndentNo: 0,
          IndentType: "Insert",
        },
      ],
      ProductDetails: selectedProducts?.map((product) => ({
        IndentId: 0,
        ProductId: product.id,
        Quantity: `${product.quantity}`,
      })),
    };

    console.log(payload, "data sending to service...");

    try {
      setSubmitBtnLoading(true);
      const response = await Axios.post(
        `${API_BASE_URL}${INSERT_STOCK_INDENT}`,
        payload
      );
      const data = response.data;
      console.log(data);
      if (data[0]["Success"] === 1) {
        setSubmitBtnLoading(false);
        Swal.fire({
          title: `Indent Added Successfully.`,
          icon: "success",
        }).then((result) => {
          if (result.isConfirmed || result.isDismissed) {
            window.location.reload();
          }
        });
      } else {
        setSubmitBtnLoading(false);
        Swal.fire({
          title: "Error",
          text: "Failed to Request Submit.",
          icon: "error",
        });
      }
    } catch (error) {
      setSubmitBtnLoading(false);
      console.error("Error:", error);
      Swal.fire({
        title: "Error",
        text: "An error occurred while processing your request.",
        icon: "error",
      });
    }
  };

  const showEditModal = (dataObj) => {
    const requestData = {
      OrgId: userDataSession.OrgId,
      CategoryId: 0,
      BarCode: "0",
      IsActive: 1,
      ProductId: 0,
      StoreId: dataObj.StoreId,
      IsForSale: 1,
      UserId: userDataSession.UserId,
      Type: 1,
    };

    if (userDataSession && userDataSession.OrgId && dataObj.StoreId) {
      Axios.post(`${API_BASE_URL}${GET_VSTORE_PROD}`, requestData)
        .then((response) => {
          if (response.data.Status) {
            setProductsData(response.data.ResultData);
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }

    if (dataObj.IndentNo) {
      const fetchData = () => {
        setLoading(true);
        Axios.get(
          `${API_BASE_URL}${GET_STOCK_INDENT_LIST}?OrgId=${userDataSession.OrgId}&IndentNo=${dataObj.IndentNo}`
        )
          .then((response) => {
            if (response.data.Status) {
              setIndentProducts(response.data.ResultData);
              setLoading(false);
            } else {
              console.error("Error fetching data:", response.data.Message);
            }
          })
          .catch((error) => {
            setLoading(false);
            console.error("Error fetching data:", error);
          });
      };
      fetchData();
    }
    setEditObj(dataObj);
  };

  const showViewModal = (dataObj) => {
    if (dataObj.IndentNo) {
      const fetchData = () => {
        setViewLoading(true);
        Axios.get(
          `${API_BASE_URL}${GET_STOCK_INDENT_LIST}?OrgId=${userDataSession.OrgId}&IndentNo=${dataObj.IndentNo}`
        )
          .then((response) => {
            if (response.data.Status) {
              setIndentProducts(response.data.ResultData);
              setViewLoading(false);
            } else {
              console.error("Error fetching data:", response.data.Message);
            }
          })
          .catch((error) => {
            setViewLoading(false);
            console.error("Error fetching data:", error);
          });
      };
      fetchData();
    }
    setViewObj(dataObj);
  };

  const showReceiveModal = (dataObj) => {
    if (dataObj.IndentNo) {
      const fetchData = () => {
        setReceiveLoading(true);
        Axios.get(
          `${API_BASE_URL}${GET_STOCK_INDENT_LIST}?OrgId=${userDataSession.OrgId}&IndentNo=${dataObj.IndentNo}`
        )
          .then((response) => {
            if (response.data.Status) {
              setIndentProducts(response.data.ResultData);
              setReceiveLoading(false);
            } else {
              console.error("Error fetching data:", response.data.Message);
            }
          })
          .catch((error) => {
            setReceiveLoading(false);
            console.error("Error fetching data:", error);
          });
      };
      fetchData();
    }
    setReceiveObj(dataObj);
  };

  const handleEditProductSelectChange = (e) => {
    const selectedProductId = parseInt(e.target.value);
    const selectedProduct = productsData.find(
      (prod) => prod.Id === selectedProductId
    );

    const productExists = indentProducts.some(
      (prod) => prod.ProductId === selectedProductId
    );

    if (selectedProduct && !productExists) {
      setIndentProducts((prevIndentProducts) => {
        const updatedProducts = [
          ...prevIndentProducts,
          {
            ProductId: selectedProduct.Id,
            ProductName: selectedProduct.ProductName,
            IndentId: 0,
            ReqQty: 0,
          },
        ];
        return updatedProducts;
      });
    }
  };

  const handleEditQuantityChange = (value, index) => {
    const updatedProducts = [...indentProducts];
    updatedProducts[index].ReqQty = value;
    setIndentProducts(updatedProducts);
  };

  const handleRemoveProduct = (productId) => {
    const updatedProducts = indentProducts.filter(
      (item) => item.ProductId !== productId
    );
    setIndentProducts(updatedProducts);
  };

  // #region handle edit submit
  const handleEditSubmit = (operation) => async (e) => {
    e.preventDefault();

    // setEditSubmitLoading(true);
    // setSelctedOperationEdit(operation);

    console.log(indentProducts, "indent products...");

    const requestData = {
      StockIndent: [
        {
          OrgId: userDataSession.OrgId,
          StoreId: editObj.StoreId,
          IndentDt: `${editFormatDate(editObj.IndentDt)}`,
          Operation: `${operation}`,
          UserId: userDataSession.UserId,
          IndentNo: `${editObj.IndentNo}`,
        },
      ],
      ProductDetails: indentProducts?.map((product) => ({
        IndentId: product.IndentId ? product.IndentId : 0,
        ProductId: product.ProductId,
        Quantity: `${product.ReqQty}`,
      })),
      Type: "Update",
    };

    if (operation == "Submit") {
      setEditSubmitLoading(true);
    } else {
      setDraftEditBtnLoading(true);
    }

    console.log(requestData, "sending to api");

    Axios.post(`${API_BASE_URL}${INSERT_STOCK_INDENT}`, requestData)
      .then((response) => {
        console.log("Response:", response.data[0].Success);

        // Assuming response.data contains a status or message indicating success
        if (response.data[0].Success === 1) {
          setEditSubmitLoading(false);
          setDraftEditBtnLoading(false);
          // Show success message
          Swal.fire({
            title: `Stock Indent Updated Successfully.`,
            icon: "success",
          }).then((result) => {
            // Optionally handle result or reload the page
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          setEditSubmitLoading(false);
          // Show error message if status indicates failure
          Swal.fire({
            title: "Error",
            text: "Failed to update Stock Indent.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        setEditSubmitLoading(false);
        setDraftEditBtnLoading(false);
        console.error("Error:", error);
        // Handle other errors if necessary
        Swal.fire({
          title: "Error",
          text: "Failed to update Stock Indent.",
          icon: "error",
        });
      });
  };

  const handleReceiveSubmit = async (e) => {
    e.preventDefault();

    setReceiveLoading(true);
    console.log(indentProducts, "indent products...", receiveObj);

    const requestData = {
      OrgId: userDataSession.OrgId,
      UserId: userDataSession.UserId,
      IndentNo: receiveObj.IndentNo,
      ProductsData: indentProducts?.map((product) => ({
        StoreId: receiveObj.StoreId ? receiveObj.StoreId : 0,
        ProductId: product.ProductId,
        ReqQuantity: product.ReqQty,
      })),
    };

    console.log(requestData, "sending to api");

    Axios.post(`${API_BASE_URL}${RECEIVE_LOCAL_INDENT_STOCK}`, requestData)
      .then((response) => {
        console.log("Response:", response.data);

        if (response.data[0].SUCCESS === 1) {
          setReceiveLoading(false);
          Swal.fire({
            title: `Stock Indent receive Successfully.`,
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          setReceiveLoading(false);
          Swal.fire({
            title: "Error",
            text: "Failed to update receive Stock Indent.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        setReceiveLoading(false);
        console.error("Error:", error);
        Swal.fire({
          title: "Error",
          text: "Failed to update Stock Indent.",
          icon: "error",
        });
      });
  };

  const handleDownloadExcel = () => {
    if (data.length === 0) {
      return; // Don't download if there is no data
    }

    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Status mapping function
    const mapStatus = (status) => {
      switch (status) {
        case 11:
          return "Draft";
        case 12:
          return "Sent";
        case 13:
          return "Approved";
        case 14:
          return "Reject";
        case 15:
          return "Closed";
        default:
          return "N/A";
      }
    };

    // Convert your data to worksheet format
    const wsData = dataSource.map((item) => ({
      "Indent Number": item.IndentNo,
      Date: formatDate(item.IndentDt),
      StoreName: item.StoreName,
      Status: mapStatus(item.IndentStatus), // Convert numeric status to letter
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "IndentData");

    // Save the workbook to a file
    XLSX.writeFile(wb, "IndentData.xlsx");
  };

  const generatePDF = () => {
    const doc = new jsPDF();

    // Set properties for PDF
    doc.setProperties({
      title: "Attendance Report",
      author: "Your Name",
      creator: "Your Application",
    });

    // Status mapping function
    const mapStatus = (status) => {
      switch (status) {
        case 1:
          return "Draft";
        case 2:
          return "Sent";
        case 3:
          return "Approved";
        case 4:
          return "Reject";
        default:
          return "N/A";
      }
    };

    // Add data to PDF
    const tableData = []; // Your data array here

    // Add a header row
    const headers = ["Number", "Date", "StoreName", "Status"];
    tableData.push(headers);

    // Add rows
    dataSource.forEach((item) => {
      const row = [];
      row.push(
        item.IndentNo,
        formatDate(item.IndentDt),
        item.StoreName,
        mapStatus(item.IndentStatus)
      );
      tableData.push(row);
    });

    // Generate table
    doc.autoTable({
      head: [headers],
      body: tableData.slice(1),
    });

    // Save the PDF
    doc.save("IndentData.pdf");
  };

  // region Excel Downlaod
  const handleAddDownloadExcel = (e) => {
    e.preventDefault();

    if (!selectedStore) {
      setExcelErrorMess("Please Select Store...");
    } else {
      const link = document.createElement("a");
      link.href = `${API_BASE_URL}${DOWNLD_EXCEL}?StoreId=${selectedStore.value}&OrgId=${userDataSession.OrgId}`;

      link.download = "filename.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  // Handle file selection
  const handleFileChange = (event) => {

    setSelectedProduct(null);
    setIsDisplayProduct(false);
    setIsDisplayProductBtn(false);
    setIsDisplayExcelBtn(true);
    setErrorMessage(`Product selection is disabled because an Excel file has already been uploaded.
      <br/> Please clear the uploaded file to enable product selection.`);

    const file = event.target.files[0];
    if (
      file &&
      (file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel")
    ) {
      setSelectedFile(file);
    } else {
      setIsDisplayProduct(true);
      alert("Please select a valid Excel file.");
    }
  };

  // #region Handle file upload
  const handleUploadExcel = (operation) => async (e) => {
    e.preventDefault();

    if (!selectedFile) {
      alert("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("OrgId", userDataSession.OrgId);
    formData.append("StoreId", `${selectedStore.value}`);
    formData.append("IndentDt", `${selectedDate}`);
    formData.append("Operation", `${operation}`);
    formData.append("UserId", userDataSession.UserId);
    formData.append("IndentType", "Insert");
    formData.append("IndentNo", "0");
    formData.append("file", selectedFile);

    try {
      // Log the formData content
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      const response = await fetch(`${API_BASE_URL}${UPLOAD_EXCEL}`, {
        method: "POST",
        body: formData,
      });

      console.log("Fetch response received:", response);

      if (response.ok) {
        const data = await response.json();
        alert("File uploaded successfully");
        window.location.reload();
        console.log(data);
      } else {
        alert("File upload failed");
        console.error("Upload failed", response.statusText);
      }
    } catch (error) {
      console.error("Error uploading file", error);
      alert("Error uploading file");
    }
  };

  const handleApprovedSubmit = async (e) => {
    e.preventDefault();
    // setApproveLoading(true);
    console.log(indentProducts);
    const requestData = {
      StockIndent: [
        {
          OrgId: userDataSession.OrgId,
          StoreId: viewObj?.StoreId,
          IndentDt: editFormatDate(viewObj?.IndentDt),
          Operation: "LOCALPURCHASEAPPROVE",
          UserId: userDataSession.UserId,
          IndentNo: viewObj?.IndentNo,
        },
      ],
      ProductDetails: indentProducts?.map((product) => ({
        IndentId: product.IndentId ? product.IndentId : 0,
        ProductId: product.ProductId,
        Quantity: product.ReqQty,
        Approvedqty: product.ReqQty,
      })),
      Type: "Update",
    };

    console.log(requestData, "sending to api for approval");

    Axios.post(`${API_BASE_URL}${INSERT_STOCK_INDENT}`, requestData)
      .then((response) => {
        console.log("Response:", response.data);

        if (response.data[0].Success === 1) {
          // setApproveLoading(false);
          Swal.fire({
            title: `Stock Indent Updated Successfully.`,
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed || result.isDismissed) {
              window.location.reload();
            }
          });
        } else {
          // setApproveLoading(false);
          Swal.fire({
            title: "Error",
            text: "Failed to update Stock Indent.",
            icon: "error",
          });
        }
      })
      .catch((error) => {
        // setApproveLoading(false);
        console.error("Error:", error);
        Swal.fire({
          title: "Error",
          text: "Failed to update Stock Indent.",
          icon: "error",
        });
      });
  };

  const handleReject = async (rejectObj) => {
    const payload = {
      IndentStatus: 14,
      OrgId: userDataSession.OrgId,
      IndentNo: rejectObj.IndentNo,
      StoreId: rejectObj.StoreId,
      Reason: rejectedReason || "null",
      UserId: userDataSession.UserId,
    };

    console.log(payload, "data sending to reject API");

    try {
      const response = await fetch(`${API_BASE_URL}${UPDATES_INDENT_STATUS}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log(data);

      if (data[0].Status == "Success") {
        Swal.fire({
          title: `Indent Rejected Successfully.`,
          icon: "success",
        }).then((result) => {
          if (result.isConfirmed || result.isDismissed) {
            window.location.reload();
          }
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Failed to Reject Indent.",
          icon: "error",
        });
      }
    } catch (error) {
      console.error("Error rejecting indent", error);
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "2.4rem",
      height: "2.4rem",
      padding: "0 8px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "2.4rem",
      padding: "0 8px",
      display: "flex",
      alignItems: "center",
    }),
    placeholder: (provided) => ({
      ...provided,
      margin: 0,
      position: "absolute",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0",
      padding: 0,
    }),
  };

  const handleReload = () => {
    window.location.reload();
  };

  const handleClearDisplay = () => {
    setSelectedProduct(null);
    setIsDisplayExcel(false);
    setIsDisplayProduct(true);
    setSelectedDate(today);
    setSelectedProducts([]);
    setSelectedFile(null);
    setIsDisplayProductBtn(true);
    setIsDisplayExcelBtn(false);
    setErrorMessage('');

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    if (storeData.length === 1) {
      const selectedStoreObj = {
        value: storeData[0].StoreId,
        label: storeData[0].Name,
      };
      setSelectedStore(selectedStoreObj);
      setSelctedFilterStore(selectedStoreObj);
    }
  }

  const handleClose = () => {

    setSelectedProduct(null);
    setSelectedDate(today);
    setSelectedProducts([]);
    setIsDisplayExcelBtn(false);
    setIsDisplayProductBtn(true);
    setErrorMessage('');

    if (storeData.length === 1) {
      const selectedStoreObj = {
        value: storeData[0].StoreId,
        label: storeData[0].Name,
      };
      setSelectedStore(selectedStoreObj);
      setSelctedFilterStore(selectedStoreObj);
    }
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Local Indent list</h4>
                <h6>Manage your Local Indents</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li onClick={generatePDF}>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li onClick={handleDownloadExcel}>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="img"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-added"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightIndAdd"
                aria-controls="offcanvasRightIndAdd"
              >
                <PlusCircle className="me-2" />
                Add Local Indent
              </Link>
            </div>
          </div>
          {/* /indent list */}
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="input-group search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      value={searchQuery}
                      onChange={handleSearch}
                    />
                    <span className="input-group-text bg-white">
                      <i data-feather="search" className="feather-search"></i>
                    </span>
                  </div>
                </div>
                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${
                      isFilterVisible ? "setclose" : ""
                    }`}
                    id="filter_search"
                  >
                    <Filter
                      className="filter-icon"
                      onClick={toggleFilterVisibility}
                    />
                    <span onClick={toggleFilterVisibility}>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="img"
                      />
                    </span>
                  </Link>
                </div>
              </div>
              {/* /Filter */}
              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row mb-2">
                    <div className="col-lg-3 col-sm-6 col-12">
                      <label>Store</label>
                      <Select
                        className="select"
                        options={[
                          { value: 0, label: "All" },
                          ...(storeData
                            ? storeData.map((store) => ({
                                value: store.StoreId,
                                label: store.Name,
                              }))
                            : []),
                        ]}
                        placeholder="Choose store"
                        onChange={handleStoreFilterChange}
                        value={selectedFilterStore || null}
                        styles={customStyles}
                      />

                      {/* </div> */}
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12">
                      <label>Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={selectedFilterDate}
                        onChange={handleFilterDateChange}
                      />
                    </div>
                    <div className="col-lg-3 col-sm-6 col-12 ms-auto">
                      <div className="input-blocks">
                        <button
                          className="btn btn-filters ms-auto"
                          onClick={fetchFilterData}
                        >
                          {" "}
                          <i
                            data-feather="search"
                            className="feather-search"
                          />{" "}
                          Search{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Filter */}
              <div className="table-responsive">
                {loading ? (
                  // <div className="loader m-auto"></div>
                  
                  <SpinLoader/>
                ) : (
                  <Table
                    columns={columns}
                    dataSource={filteredDataSource}
                    locale={{
                      emptyText: "No data available",
                    }}
                  />
                )}
              </div>
            </div>
          </div>
          {/* /indent list */}
        </div>
      </div>

      {/* Add */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightIndAdd"
        aria-labelledby="offcanvasRightLabel"
        style={{ maxWidth: offcanvasWidth }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Add Local Indent</h4>
          <p className="text-danger fw-semibold">{excelErrorMess}</p>
          <div className="d-flex ms-auto align-items-center">
            <div className="d-flex justify-content-end align-items-center">
              <p className="mb-0">Download Template</p>
              <button
                className="btn d-flex"
                title="Download template"
                onClick={handleAddDownloadExcel}
              >
                <i className="fa-solid fa-download text-danger fs-4"></i>
              </button>
            </div>
            <button
              type="button"
              className="btn-close text-reset ms-2"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
              onClick={handleClose}
            />
          </div>
        </div>{" "}
        <hr />
        <div className="offcanvas-body">
          <div className={`alert alert-warning ${errorMessage.length > 1 ? 'd-block' : 'd-none'}`} dangerouslySetInnerHTML={{ __html: errorMessage }}></div>
          <form>
            <div className="row mb-2">
              <div className="col-lg-6 col-md-6 mb-3">
                <label className="form-label">
                  Store<span className="fw-bold text-danger">*</span>
                </label>
                <Select
                  className="select"
                  options={
                    storeData &&
                    storeData?.map((store) => ({
                      value: store.StoreId,
                      label: store.Name,
                    }))
                  }
                  placeholder="Choose store"
                  value={selectedStore || ""}
                  onChange={handleStoreSelectChange}
                  styles={customStyles}
                />
              </div>
              <div className="col-lg-6 col-md-6 mb-1">
                <label className="form-label">
                  Date<span className="fw-bold text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="SubCategoryName"
                  name="Date"
                  value={selectedDate}
                  onChange={handleDateChange}
                />
              </div>

              <div className="col-12">
                <label className="form-label">By Excel</label>
                <input
                  type="file"
                  accept=".xlsx, .xls"
                  className="form-control me-2"
                  style={{ width: "100%", height: "2.5rem" }}
                  onChange={handleFileChange}
                  disabled={isDisplayExcel}
                  ref={fileInputRef}
                />
              </div>

              <div className="col-12 my-3">
                <label className="form-label">Product</label>
                <Select
                  className="select"
                  options={
                    productsData && productsData.length > 0
                      ? productsData?.map((prod) => ({
                          value: prod.Id,
                          label: prod.ProductName,
                        }))
                      : []
                  }
                  placeholder="Choose product"
                  onChange={handleProductSelectChange}
                  styles={customStyles}
                  isDisabled={!isDisplayProduct}
                  value={selectedProduct}
                />
              </div>

              <div
                className="col-12 table-responsive mt-2"
                style={{ overflowY: "auto", maxHeight: "190px" }}
              >
                <table className="table datanew">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Product</th>
                      <th>Quantity</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedProducts?.map((product, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{product.name}</td>
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter quantity"
                            value={product.quantity}
                            onChange={(e) =>
                              handleQuantityChange(e.target.value, index)
                            }
                            style={{ width: "5rem" }}
                            onWheel={(e) => e.target.blur()}
                          />
                        </td>
                        <td>
                          <button
                            className="btn border text-danger"
                            onClick={(e) => handleDelete(index, e)}
                          >
                            <i className="feather-trash-2 fs-6"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="modal-footer-btn d-flex justify-content-end sticky-bottom">
              <button
                type="button"
                className="btn btn-danger me-2"
                onClick={handleClearDisplay}
                disabled={submitBtnLoading}
              >
                Clear
              </button>
              
              <button
                type="submit"
                className={`btn btn-primary me-2 ${isDisplayProductBtn ? 'd-block' : 'd-none'}`}
                onClick={handleSubmit("LOCALPURCHASEDRAFT")}
              >
                {submitBtnLoading ? "Saving..." : "Save as Draft"}
              </button>
              <button
                type="submit"
                className={`btn btn-success ${isDisplayProductBtn ? 'd-block' : 'd-none'}
                  
                `}
                // ${addBtnStatus === 'Yes' ? "d-block" : "d-none"}
                onClick={handleSubmit("LOCALPURCHASEDRAFT")}
                disabled={submitBtnLoading}
              >
                {submitBtnLoading ? "Submitting..." : "Submit"}
              </button>

              <button
                type="submit"
                className={`btn btn-primary me-2 ${isDisplayExcelBtn ? 'd-block' : 'd-none'}`}
                onClick={handleUploadExcel("LOCALPURCHASEDRAFT")}
                disabled={submitBtnLoading}
              >
                {submitBtnLoading ? "Saving..." : "Save as Draft"}
              </button>
              <button
                type="submit"
                className={`btn btn-success ${isDisplayExcelBtn ? 'd-block' : 'd-none'}
                  
                `}
                // ${addBtnStatus === 'Yes' ? "d-block" : "d-none"}
                onClick={handleUploadExcel("LOCALPURCHASESENT")}
                disabled={submitBtnLoading}
              >
                {submitBtnLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Edit */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightIndEdit"
        aria-labelledby="offcanvasRightLabel"
        style={{ maxWidth: offcanvasWidth }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Edit Local Indent</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>{" "}
        <hr />
        <div className="offcanvas-body">
          <p className="fw-semibold">{editObj.IndentNo}</p>
          <form>
            <div className="row">
              <div className="col-lg-6 col-md-6 mb-3">
                <label className="form-label">Store</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Store Name"
                  value={editObj.StoreName}
                  style={{ cursor: "not-allowed" }}
                  readOnly
                />
              </div>
              <div className="col-lg-6 col-md-6 mb-1">
                <label className="form-label">Date</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Date"
                  value={formatDate(editObj.IndentDt)}
                  style={{ cursor: "not-allowed" }}
                  readOnly
                />
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">Product</label>
                <select
                  className="form-select"
                  onChange={handleEditProductSelectChange}
                >
                  <option value="">Select a product</option>
                  {productsData?.map((item, index) => (
                    <option key={index} value={item.Id}>
                      {item.ProductName}
                    </option>
                  ))}
                </select>
              </div>
              <br />
              <div className="col-12 table-responsive mt-2">
                <table className="table datanew">
                  <thead className="sticky-top">
                    <tr>
                      <th className="">#</th>
                      <th className="">Product</th>
                      <th className="">Quantity</th>
                      <th className="">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {indentProducts &&
                      indentProducts?.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.ProductName}</td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter quantity"
                              value={item.ReqQty}
                              onChange={(e) =>
                                handleEditQuantityChange(e.target.value, index)
                              }
                              onWheel={(e) => e.target.blur(e)}
                            />
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn border text-danger"
                              onClick={() =>
                                handleRemoveProduct(item.ProductId)
                              }
                            >
                              <i className="feather-trash-2 fs-6"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="modal-footer-btn">
              <button
                type="button"
                className="btn btn-cancel me-2"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary me-2"
                onClick={handleEditSubmit("LOCALPURCHASEDRAFT")}
                disabled={draftEditBtnLoading}
              >
                {draftEditBtnLoading ? "Saving..." : "Save as Draft"}
              </button>
              <button
                type="submit"
                className="btn btn-success"
                onClick={handleEditSubmit("LOCALPURCHASESENT")}
                disabled={editSubmitLoading}
              >
                {editSubmitLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* View */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightLocalIndView"
        aria-labelledby="offcanvasRightLabel"
        style={{ maxWidth: offcanvasWidth }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">
            View Local Indent
            <span className="fw-bold text-info">({viewObj.IndentNo})</span>
          </h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
          <form onSubmit={handleApprovedSubmit}>
            <div className="row">
              <div className="col-lg-6 col-md-6 mb-3">
                <label className="form-label">Store</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Store Name"
                  value={viewObj.StoreName}
                  style={{ cursor: "not-allowed" }}
                  readOnly
                />
              </div>
              <div className="col-lg-6 col-md-6 mb-1">
                <label className="form-label">Date</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Date"
                  value={formatDate(viewObj.IndentDt)}
                  style={{ cursor: "not-allowed" }}
                  readOnly
                />
              </div>

              <div className="col-12 table-responsive mt-2">
                <table className="table datanew">
                  <thead className="sticky-top">
                    <tr>
                      <th className="">#</th>
                      <th className="">Product</th>
                      <th className="">Purchased Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {viewLoading ? (
                      <tr>
                        <td colSpan="100%" className="text-center">
                          <div className="loader m-auto"></div>
                        </td>
                      </tr>
                    ) : (
                      indentProducts &&
                      indentProducts?.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.ProductName}</td>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              style={{ cursor: "not-allowed", width: "9rem" }}
                              value={item.ReqQty}
                              readOnly
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              <div
                className={`mt-3 ${
                  viewObj?.IndentStatus === 13 || viewObj?.IndentStatus === 12
                    ? "d-block"
                    : "d-none"
                }`}
              >
                <label className="form-label">Reason</label>
                <textarea
                  className="form-control col-12"
                  placeholder="Enter reason for reject.."
                  value={rejectedReason}
                  onChange={(e) => setRejectedReason(e.target.value)}
                ></textarea>
              </div>
            </div>

            <div className="modal-footer-btn d-flex justify-content-end sticky-bottom">
              <button
                type="button"
                className="btn btn-cancel me-2"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                Cancel
              </button>
              <button
                type="submit"
                className={`btn btn-success me-2 ${
                  [1, 2, 4].includes(userDataSession.RoleId)
                    ? viewObj.IndentStatus === 14 ||
                      viewObj?.IndentStatus === 12
                      ? "d-block"
                      : "d-none"
                    : "d-none"
                }`}
                // onClick={() => showApproveModal(viewObj)}
              >
                Approve <i className="fa-regular fa-circle-check ms-1"></i>
              </button>
              <button
                type="button"
                className={`btn btn-danger me-2 ${
                  [1, 2, 4].includes(userDataSession.RoleId)
                    ? viewObj?.IndentStatus === 13 ||
                      viewObj?.IndentStatus === 12
                      ? "d-block"
                      : "d-none"
                    : "d-none"
                }`}
                onClick={() => handleReject(viewObj)}
              >
                Reject <i className="fa-regular fa-circle-xmark ms-1"></i>
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Receive Stock */}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightLocalIndReceive"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: offcanvasWidth }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">
            Receive Stock{" "}
            <span className="fw-bold text-info">({viewObj.IndentNo})</span>
          </h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>{" "}
        <hr />
        <div className="offcanvas-body">
          {receiveLoading ? (
            <div className="loader m-auto"></div>
          ) : (
            <form onSubmit={handleReceiveSubmit}>
              <div className="row">
                <div className="col-lg-6 col-md-6 mb-3">
                  <label className="form-label">Store</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Store Name"
                    value={receiveObj?.StoreName}
                    style={{ cursor: "not-allowed" }}
                    readOnly
                  />
                </div>
                <div className="col-lg-6 col-md-6 mb-1">
                  <label className="form-label">Date</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Date"
                    value={formatDate(receiveObj.IndentDt)}
                    style={{ cursor: "not-allowed" }}
                    readOnly
                  />
                </div>

                <div className="col-12 table-responsive mt-2">
                  <table className="table datanew">
                    <thead className="sticky-top">
                      <tr>
                        <th className="">#</th>
                        <th className="">Product</th>
                        <th className="">Purchased Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {viewLoading ? (
                        <tr>
                          <td colSpan="100%" className="text-center">
                            <div className="loader m-auto"></div>
                          </td>
                        </tr>
                      ) : (
                        indentProducts &&
                        indentProducts?.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.ProductName}</td>
                            <td>
                              <input
                                type="number"
                                className="form-control"
                                style={{ cursor: "not-allowed", width: "9rem" }}
                                value={item.ReqQty}
                                readOnly
                              />
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="modal-footer-btn d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-cancel me-2"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className={`btn btn-success me-2 ${
                    [1, 3, 2].includes(userDataSession.RoleId)
                      ? receiveObj?.IndentStatus === 13
                        ? "d-block"
                        : "d-none"
                      : "d-none"
                  }`}
                >
                  Receive <i className="fa-regular fa-circle-check ms-1"></i>
                </button>
              </div>
            </form>
          )}
        </div>
      </div>

      {/* <UploadFiles number={uploadInvoiceObj.IndentNo} type={"Indent"} /> */}
      <UploadFiles 
        number={uploadInvoiceObj?.IndentNo?.replace(/^\D+-/, '') || ''} 
        type={"LocalIndent"} 
      />

    </div>
  );
};

export default LocalIndent;
